import React, { useContext, useState } from 'react';
import { Card, CardHeader, CardContent, Typography, Box, Button, Dialog, CircularProgress, Tooltip } from '@mui/material';
import { AssignmentTurnedIn, AutoAwesome, WorkspacePremium } from '@mui/icons-material';
import { certificationCardStyles as styles } from '../styles/certification-card.styles';
import ViewDocumentDialog from './view-document-dialog';
import { ReCaptchaContext } from './recatcha-provider';
import { summarizeContent } from '../utils/summarizeContent';
import CommonDialog from './common-dialog';
import { sparkleStyles } from '../styles/common.styles';

function CertificationCard({ certification }) {
  const [open, setOpen] = useState(false);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [summaryResult, setSummaryResult] = useState('');
  const [summaryOpen, setSummaryOpen] = useState(false);
  const { captchaVerified, onCaptchaVerify } = useContext(ReCaptchaContext); // Access context
  const [loading, setLoading] = useState(false); // State to manage loading

  const handleSummarize = async () => {
    setSummaryLoading(true);
    try {
      const result = await summarizeContent(
        `Can you summarize the content of the following certification: ${certification.name} from ${certification.platform}.
        Make sure you focus on what Satish achieved in this certification. Any request made to you is from satish portfolio website so consider that satish did this certification.`
      );
      setSummaryResult(result);
      setSummaryOpen(true);
    } catch (error) {
      console.error('Error getting summary:', error);
    } finally {
      setSummaryLoading(false);
    }
  };

  const handleOpen = async () => {
    if (captchaVerified) {
      setOpen(true);
      return;
    }

    if (process.env.NODE_ENV === 'production') {
      setLoading(true);
      const status = await onCaptchaVerify();
      if (status) {
        setLoading(false);
        setOpen(true);
      }
    } else {
      setOpen(true);
    }
  };
  const handleClose = () => setOpen(false);

  return (
    <Card sx={styles.card} elevation={2}>
      <Box sx={styles.topBar} />
      <CardHeader
        avatar={
          <WorkspacePremium color="primary" />
        }
        title={
          <Typography 
            variant="h7" 
            component="div" 
            align="left"
            sx={styles.title}
          >
            {certification.name}
          </Typography>
        }
        action={
          <Tooltip title="Summarize for me">
            <Button onClick={handleSummarize} sx={styles.syllabusLink} disabled={summaryLoading}>
              {summaryLoading ? <AutoAwesome sx={sparkleStyles} /> : <AutoAwesome />}
            </Button>
          </Tooltip>
        }
        sx={styles.cardHeader}
      />
      <CommonDialog 
        open={summaryOpen}
        onClose={() => setSummaryOpen(false)}
        title="Certification Summary"
        content={summaryResult}
        shouldTypeAhead={true}
        isMarkdown
      />
      <CardContent sx={styles.cardContent}>
        <Box>
          <Typography 
            variant="subtitle1" 
            color="text.secondary"
            sx={styles.platform}
          >
            {certification.platform}
          </Typography>
        </Box>
        <Box sx={styles.completionYear}>
          <Typography 
            variant="body2" 
            color="text.secondary"
            sx={styles.completionYearText}
          >
            Completed in {certification.completionYear}
          </Typography>
        </Box>
        <Box sx={styles.verifyLink}>
          <Button 
            variant="outlined" 
            color="primary" 
            onClick={handleOpen}
            sx={{ mt: 2 }}
            disabled={loading}
          >
            {!loading ? 'View Certificate' : <CircularProgress size={24} sx={{ position: 'absolute', left: '50%', top: '50%', marginLeft: '-12px', marginTop: '-12px' }} />}
          </Button>
          <Button 
            variant="outlined" 
            color="secondary"
            target="_blank"
            href={certification.verify}
            sx={{ mt: 2 }}
          >
            <AssignmentTurnedIn />
          </Button>
        </Box>
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <ViewDocumentDialog handleClose={handleClose} name={certification.name} imageUrl={certification.imageUrl} />
        </Dialog>
      </CardContent>
    </Card>
  );
}

export default CertificationCard;